import { render, staticRenderFns } from "./IngredientImage.vue?vue&type=template&id=02516d32&scoped=true&"
import script from "./IngredientImage.vue?vue&type=script&lang=js&"
export * from "./IngredientImage.vue?vue&type=script&lang=js&"
import style0 from "./IngredientImage.vue?vue&type=style&index=0&id=02516d32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02516d32",
  null
  
)

export default component.exports